// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__M-hid","question":"Question_question__2hkGy","description":"Question_description__2YzA6"};